const CART_DISCOUNT_STORAGE_KEY = 'prime-cart-discount-code';

function getStoredDiscount() {
  try {
    return sessionStorage.getItem(CART_DISCOUNT_STORAGE_KEY) || '';
  } catch (_) {
    return '';
  }
}

function setStoredDiscount(code) {
  try {
    if (code) sessionStorage.setItem(CART_DISCOUNT_STORAGE_KEY, code);
    else sessionStorage.removeItem(CART_DISCOUNT_STORAGE_KEY);
  } catch (_) {}
}

function attachCheckoutInterceptor() {
  // Intercept ALL checkout buttons/forms — append ?discount=CODE so it carries into checkout.
  document.addEventListener(
    'click',
    (event) => {
      const checkoutBtn = event.target.closest('button[name="checkout"], a[href*="/checkout"]');
      if (!checkoutBtn) return;
      const code = getStoredDiscount();
      if (!code) return;

      // Button inside a form (cart submit)
      if (checkoutBtn.tagName === 'BUTTON') {
        const form = checkoutBtn.form || checkoutBtn.closest('form');
        if (form && !form.querySelector('input[name="discount"]')) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'discount';
          hidden.value = code;
          form.appendChild(hidden);
        }
        // Also rewrite action to include ?discount=
        if (form && form.action && form.action.indexOf('discount=') === -1) {
          const sep = form.action.indexOf('?') >= 0 ? '&' : '?';
          form.action = form.action + sep + 'discount=' + encodeURIComponent(code);
        }
        return;
      }

      // Plain anchor link
      if (checkoutBtn.tagName === 'A') {
        const href = checkoutBtn.getAttribute('href') || '';
        if (href.indexOf('discount=') === -1) {
          const sep = href.indexOf('?') >= 0 ? '&' : '?';
          checkoutBtn.setAttribute('href', href + sep + 'discount=' + encodeURIComponent(code));
        }
      }
    },
    true // capture phase so we run before other handlers/navigation
  );
}

// Run the interceptor once per page load
attachCheckoutInterceptor();

if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.cart-discount__input');
        this.applyBtn = this.querySelector('.cart-discount__apply');
        this.message = this.querySelector('.cart-discount__message');

        if (this.applyBtn) {
          this.applyBtn.addEventListener('click', () => this.apply());
        }
        if (this.input) {
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.apply();
            }
          });
        }

        // Reflect a previously applied code so the user sees it
        const existing = getStoredDiscount();
        if (existing && this.input && !this.input.value) {
          this.input.value = existing;
          this.showMessage('Code applied — will be used at checkout.', false);
        }
      }

      get cartUrl() {
        return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      }

      showMessage(text, isError) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.hidden = false;
        this.message.classList.toggle('cart-discount__message--error', !!isError);
        this.message.classList.toggle('cart-discount__message--success', !isError);
      }

      async apply() {
        const code = (this.input.value || '').trim();
        if (!code) return;

        this.applyBtn.disabled = true;
        this.applyBtn.classList.add('loading');
        this.showMessage('Applying…', false);

        try {
          await fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });

          const cart = await (await fetch(`${this.cartUrl}.js`, { credentials: 'same-origin' })).json();
          const match = (cart.discount_codes || []).find(
            (d) => d.code && d.code.toLowerCase() === code.toLowerCase()
          );
          const applicable = match && match.applicable !== false;

          if (applicable) {
            setStoredDiscount(code);
            await this.refresh();
          } else {
            setStoredDiscount('');
            this.applyBtn.disabled = false;
            this.applyBtn.classList.remove('loading');
            this.showMessage('Invalid, expired, or not applicable discount code.', true);
          }
        } catch (e) {
          this.applyBtn.disabled = false;
          this.applyBtn.classList.remove('loading');
          this.showMessage('Could not apply the code. Please try again.', true);
        }
      }

      async refresh() {
        // If cart drawer exists, refresh it
        if (document.querySelector('cart-drawer-items')) {
          const res = await fetch(`${this.cartUrl}?section_id=cart-drawer`, { credentials: 'same-origin' });
          const text = await res.text();
          const html = new DOMParser().parseFromString(text, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          });
          return;
        }

        // Otherwise reload the main cart page so server-rendered totals/discounts reflect
        window.location.reload();
      }
    }
  );
}
